enum ItemTypes {
  Flow = "Flow",
}

export default ItemTypes;
